
export default {
  name: 'BlocksArticleStickyNav',
  props: {
    // CSS selector for the article content container
    contentSelector: {
      type: String,
      default: 'article',
    },
    // Which heading levels to include
    headingLevels: {
      type: Array,
      default: () => ['h2'],
    },
  },
  data() {
    return {
      isStuck: false,
      activeSection: null,
      navLinks: [],
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.buildNavLinks()
      window.addEventListener('scroll', this.onScroll, { passive: true })
      this.onScroll()
    })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    // Build nav links from headings found in the content container
    buildNavLinks() {
      const container = document.querySelector(this.contentSelector)
      if (!container) {
        console.warn(`ArticleStickyNav: no element found for selector "${this.contentSelector}"`)
        return
      }

      const headings = Array.from(container.querySelectorAll(this.headingLevels.join(', ')))

      // Only include headings that already have an id
      this.navLinks = headings
        .filter(el => el.id)
        .map(el => ({
          id: el.id,
          label: el.textContent.trim(),
        }))
    },
    onScroll() {
      this.isStuck = window.scrollY >= (this.$refs.nav?.offsetTop || 0)

      const offsets = this.navLinks
        .map(l => {
          const el = document.querySelector(`#${l.id}`)
          if (!el) return null
          const top = el.getBoundingClientRect().top + window.scrollY - 150
          return { id: l.id, top }
        })
        .filter(Boolean)

      const current = offsets.filter(s => window.scrollY >= s.top).pop()
      const newActive = current?.id || null

      // Only scroll the nav if the active section has changed
      if (newActive !== this.activeSection) {
        this.activeSection = newActive
        this.$nextTick(() => this.scrollNavToActive())
      }
    },

    // Horizontally scroll the nav list to bring the active item into view
    scrollNavToActive() {
      const list = this.$refs.list
      if (!list || !this.activeSection) return

      const activeEl = list.querySelector(`a[href="#${this.activeSection}"]`)
      if (!activeEl) return

      const listRect = list.getBoundingClientRect()
      const itemRect = activeEl.getBoundingClientRect()

      // Centre the active item in the scroll container
      const offset = itemRect.left - listRect.left - (listRect.width / 2) + (itemRect.width / 2)
      list.scrollBy({ left: offset, behavior: 'smooth' })
    },
    scrollTo(id) {
      const el = document.querySelector(`#${id}`)
      if (!el) return
      const navHeight = this.$refs.nav?.offsetHeight || 0
      const absoluteTop = el.getBoundingClientRect().top + window.scrollY
      window.scrollTo({ top: absoluteTop - navHeight - 70, behavior: 'smooth' })
    },
  },
}
